import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import { NewsFeedAddEdit, DeleteConfirmationModal } from '../../shared';
import { Edit, Delete } from '../../../assets/svg';
import { popup, deleteNewsFeed } from '../../../utils';
import { NEWS_FEED, QUERY_KEYS } from '../../../constants';

export const NewsFeedOperation = ({ data, debouncedApiCall }) => {
    const queryClient = useQueryClient()
    const [openEditModal, setOpenEditModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const handleDeleteModalClick = () => {
        setIsDeleteModal(true);
    };

    const deleteMutation = useMutation({
        mutationFn: async (selectedItemId) => await deleteNewsFeed({ id: selectedItemId }),
        onSuccess: () => {
            popup('error', NEWS_FEED.DELETED_MESSAGE);
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.NEWS_FEED],
                exact: false,
            });
            setIsDeleteModal(false);
        },
        onError: (error) => popup('error', error.message),
    });

    return (
        <>
            <div className='d-flex gap-2 align-items-center justify-content-start options-set'>
                <button
                    className='border-0 p-0 bg-white'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-edit'
                    onClick={() => setOpenEditModal(true)}
                    id='action-btn'
                    title='Edit'
                >
                    <Edit />
                </button>

                <button
                    className='border-0 p-0 bg-white'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-del'
                    onClick={() => handleDeleteModalClick(data?.id)}
                    id='action-btn'
                    title='Delete'
                >
                    <Delete />
                </button>
            </div>
            {openEditModal && (
                <NewsFeedAddEdit
                    openEditModal={openEditModal}
                    setOpenEditModal={setOpenEditModal}
                    data={data}
                    isEdit={true}
                    debouncedApiCall={debouncedApiCall}
                />
            )}
            {isDeleteModal && (
                <DeleteConfirmationModal
                    isDeleteModal={isDeleteModal}
                    setIsDeleteModal={setIsDeleteModal}
                    selectedItemId={data?.id}
                    handleDeleteClick={({ selectedItemId }) =>
                        deleteMutation.mutate(selectedItemId)
                    }
                    isDisabled={deleteMutation.isPending}
                    deleteButtonName={NEWS_FEED.TITLE}
                    isLoading={deleteMutation.isPending}
                />
            )}
        </>
    );
};

NewsFeedOperation.propTypes = {
    data: PropTypes.object.isRequired,
    debouncedApiCall: PropTypes.func,
};
